import axios from "axios";
import { useEffect } from "react";
import { API_URL } from "../utilities/api.constants";
import { authHeader, authHeaderRefreshToken } from "../utilities/auth.header";

const get = async path => {
  return await axios.get(API_URL + path, { headers: authHeader() });
};

const getNonAuth = async path => {
  return await axios.get(API_URL + path);
};

const post = async (path, data) => {
  return await axios.post(API_URL + path, data);
};

const postAuth = async (path, data) => {
  return await axios.post(API_URL + path, data, { headers: authHeader() });
};

const postExternal = async (path, data) => {
  return await axios.post(path, data);
};

const put = (path, data) => {
  return axios.put(API_URL + path, data, { headers: authHeader() });
};

const getDocuments = path => {
  return axios.get(API_URL + path, {
    headers: authHeader(),
    responseType: "blob"
  });
};


const getRefreshToken = async path => {
  return await axios.get(API_URL + path, { headers: authHeaderRefreshToken() });
};

const handleResponse = response => {
  const data = response.data;
  if (response.status !== 200) {
    if (response.status === 401 || data?.responseCode === 401) {
      // auto logout if 401 response returned from api
      sessionStorage.removeItem("token");
    }
    const error = (data && data.message) || response.status;
    return Promise.reject(error);
  }
  return data;
};

const AxiosErrorHandler = ({ children }) => {
  useEffect(() => {
    const responseInterceptor = axios.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      if (error.response?.status) {
        switch (error.response.status) {
          case 401:
            if (error.response.data == 'LoggingInFromDifferentBrowser') {
              sessionStorage.setItem("LoggingInFromDifferentBrowser", true);
            } else {
              sessionStorage.setItem("LoggingInFromDifferentBrowser", false);
            }
            let token = sessionStorage.getItem("token");
            if (token) {
              sessionStorage.removeItem("token");
              //window.location.replace("/giris");
            }
            break;
          // case 403:
          //   sessionStorage.removeItem("token");
          //   break;
        }
      }
      return Promise.reject(error);
    });

    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);
  return children;
};

export { get, getNonAuth, post, postAuth, put, getDocuments, handleResponse, AxiosErrorHandler, getRefreshToken };

